/**
 * Custom Header Component
 *
 * A clean header with search trigger, notifications, and avatar.
 * Uses existing RightContent components.
 */

import React from 'react';
import RightContent from '@/components/RightContent';
import styles from './AppLayout.module.less';

interface HeaderProps {
  sidebarCollapsed: boolean;
}

export const Header: React.FC<HeaderProps> = ({ sidebarCollapsed }) => {
  return (
    <header
      className={`${styles.header} ${sidebarCollapsed ? styles.headerSidebarCollapsed : styles.headerSidebarExpanded}`}
    >
      <div className={styles.headerContent}>
        <RightContent />
      </div>
    </header>
  );
};

export default Header;

